/**
 * What gets checked — two switches instead of two buttons in the bar.
 *
 * They belong together, and in the bar they cost the width that the paper
 * needs.
 */

import type { RefObject } from 'preact'
import * as st from '../state.js'
import { Panel, Toggle } from './Panel.js'

export function CheckPanel({ anchor }: { anchor: RefObject<HTMLButtonElement> }) {
  const open = st.panel.value === 'check'

  return (
    <Panel
      open={open}
      title="Prüfung"
      anchor={anchor}
      onClose={() => (st.panel.value = null)}
    >
      <Toggle checked={st.checking.value} onChange={(v) => (st.checking.value = v)}>
        Rechtschreibung prüfen
      </Toggle>

      <Toggle
        checked={st.commas.value}
        // Without the check there are no findings at all — then the comma
        // switch has nothing it could act on, and would be only a dead
        // switch.
        disabled={!st.checking.value}
        onChange={(v) => (st.commas.value = v)}
      >
        Kommafehler mitzählen
      </Toggle>

      <p class="docs-note">
        Ohne Kommas bleiben die Stellen sichtbar, aber leise — und zählen nicht mit.
      </p>

      {/* Only when LanguageTool cannot be reached. The app then goes on
          checking with the built-in dictionary; that must be said, but not
          permanently in the bar. */}
      {st.checkWarning.value && (
        <p class="check-warning">
          Prüfung nicht verfügbar — Kritzl prüft mit dem eingebauten Wörterbuch weiter.
        </p>
      )}
    </Panel>
  )
}
